import React, { useEffect, useState } from 'react';
import Data from '../../Data/Data.json'
import { Button, Typography, Spin } from 'antd';
import Table from '../TableResizable';
import { useNavigate } from 'react-router-dom';
import { Backspace, Print } from '@mui/icons-material';
import { Box, ButtonGroup, Button as ButtonI } from '@mui/material';
import { ExcelExport, ExcelExportColumn } from "@progress/kendo-react-excel-export";
import { useAuthUser } from '../../Services/Auth/sessionAuth';
import Utilisateur from '../../Models/Utilisateur';
import Logo from "../../Res/greenLogo.png";
import ExcelIcon from '../../Res/ExcelIcon.svg';
import PageNotFound from '../../Pages/PageNotFound';
import ReformatNumber from '../../Functions/Traitement/ReformatNumber';
import ExcelIntDeb from '../../Models/ExcelIntDeb';
import i18next from 'i18next';

const PrintINTDEB = () => {
    const [tab, setTab] = React.useState(localStorage.getItem(Data.LocalVariable.tabINTDEB) ? JSON.parse(localStorage.getItem(Data.LocalVariable.tabINTDEB) + "") : null as any)
    const navigate = useNavigate();
    const [DataExcel, SetDataExcel] = useState<ExcelIntDeb[]>([]);
    const [start, setstart] = useState(false);

    useEffect(
        () => {
            exportExcel();
        },
        []);

    // USER SESSION$
    const auth = useAuthUser();
    const user: Utilisateur = JSON.parse(JSON.stringify(auth()));
    //loading Boutton  
    const [loading, setLoading] = useState(false);
    const _exporter = React.createRef<ExcelExport>();
    const exportExcel = () => {
        SetDataExcel([]);
        setLoading(true);

        tab?.data.map((data: any, indice: any) => {
            DataExcel.push({
                key: indice,
                AEDUCP: data.AEDUCP,
                NODUCP: data.NODUCP,
                numcli: data.numcli,
                NOMCPT: data.NOMCPT,
                LECECP: data.LECECP,
                MONTAN: ReformatNumber(data.MONTAN ? data.MONTAN : ''),
                TXMONT: ReformatNumber(data.TXMONT ? data.TXMONT : ''),
                TYPOPE: data.TYPOPE,
                SENSEC: data.SENSEC,
                CDLBEC: data.CDLBEC,
                DATECR: data.DATECR,
                LIBELL: data.LIBELL,
                REPECE: data.REPECE,
                DEDEVR: data.DEDEVR,
                CDEEXO: data.CDEEXO,
                CDDEVS: data.CDDEVS,
                CODANA: data.CODANA,
                INTAUX: data.INTAUX,
                INTYPE: data.INTAUX,
                TYPCALC: data.TYPCALC,
                CODIFIE: data.CODIFIE,
                montfrais: ReformatNumber(data.montfrais ? data.montfrais : ''),
                solvei: ReformatNumber(data.solvei ? data.solvei : ''),
                UTISAI: data.UTISAI
            })
        })

        if (!_exporter.current) {
            return;
        }
        _exporter.current.save();
    };

    const handleExport = () => {
        setLoading(false);
    }

    setTimeout(() => {
        if (tab == null) {
            navigate("/businessmensuel/calculagios")
        }
    }, 2000)

    return (
        <div><br />
            {tab ?
                <>
                    <Spin spinning={loading} size='large' style={{ color: 'green' }} >
                        <Box className='backBtnt' zIndex={2} onClick={() => { navigate("/businessmensuel/calculagios") }}><Backspace /></Box>
                        <ExcelExport filterable={true} data={DataExcel} fileName={tab?.Titre+"_"+user.codage+"_"+user.coduti+"_"+Data.LocalVariable.appName+"_"+Date.now()+".xlsx"}   ref={_exporter} onExportComplete={handleExport}>
                            <ExcelExportColumn field="AEDUCP" title="AGENCE" locked={true} width={100} />
                            <ExcelExportColumn field="NODUCP" title="NUMCPT" locked={true} width={150} />
                            <ExcelExportColumn title="NUMCLI" field="numcli" width={150} locked={true} />
                            <ExcelExportColumn title="MONTAN" field="MONTAN" width={80} locked={true} />
                            <ExcelExportColumn title="REPECE" field="REPECE" width={150} locked={true} />
                            <ExcelExportColumn title="SENSEC" field="SENSEC" locked={true} />
                            <ExcelExportColumn title="TXMONT" field="TXMONT" />
                            <ExcelExportColumn title="LIBELL" field="LIBELL" width={300} />
                            <ExcelExportColumn title="INTAUX" field="INTAUX" width={100} />
                            <ExcelExportColumn title="MONTFRAIS" field="montfrais" width={100} />
                            <ExcelExportColumn title="SOLDVEILLE" field="solvei" width={100} />
                            <ExcelExportColumn title="UTISAI" field="UTISAI" width={100} />
                        </ExcelExport>
                        <Box marginLeft={'1%'} className={"preview_print"}>
                            <Box className={"title"} display={"flex"} fontStyle={"inherit"}>
                                <img className='printLogo' src={Logo} width={80} />
                                <Typography style={{ textAlign: 'center', marginLeft: '35%' }} className='textTitle'><b> {tab?.Titre.toUpperCase()}   </b> </Typography >
                                <hr className='hide' />
                                <Box display={'flex'} gap={'1em'} marginLeft={'40%'}>
                                    <Button title='Imprimer ( ctrl + p )' onClick={() => { window.print() }} size='large' className='bt_add' type="ghost" htmlType="button"   ><Print /> </Button>
                                    <ButtonGroup disableElevation color='success' sx={{ gap: 1 }} variant="outlined" aria-label="Disabled elevation buttons" >
                                        <img style={{ width: 25 }} onClick={exportExcel} src={ExcelIcon}></img>
                                    </ButtonGroup>
                                </Box>
                                {/* <Box display={'fle  marginLeft={'40%'}x'} gap={'1em'}>
                                    <Button title='Imprimer ( ctrl + p )' onClick={() => { window.print() }} icon={<Print />} size='large' className='bt_add' type="ghost" htmlType="button" block  ></Button>
                                    <Button onClick={exportExcel} className='ExelExport' size='large' type='link' > <img src={ExcelIcon}></img> </Button>
                                </Box> */}
                            </Box><br />
                            <Box display={"flex"} fontStyle="inherit">
                                <Box width={"50%"} >
                                    <Box width={"120%"} display={"flex"}><Typography>AGENCE : </Typography><Typography style={{ marginLeft: '2%' }} ><b>{user.codage}</b> {user.agence}</Typography></Box>
                                    <hr />
                                </Box>
                                <Box style={{ marginLeft: '5%' }} width={"50%"}>
                                    <Box className='haut' width={"120%"} display={"flex"}><Typography >{"Imprimé par " + user.codage + " - " + user.nomuti + " le " + (new Date(Date.now())).toLocaleDateString(i18next.language) + " à " + (new Date(Date.now())).toLocaleTimeString(i18next.language)}</Typography></Box>
                                </Box>
                            </Box>
                            <Table size='small' showHeader bordered={true} columns={tab?.columns} dataSource={tab.data} />
                            <Box sx={{ marginLeft: '35%' }}>
                                <Typography  > <b> Total Commission: {tab?.Total}</b></Typography>
                            </Box>
                        </Box>
                    </Spin>
                </>
                :
                <PageNotFound message={"Nothing to print"} backLink={"/"} texttButton={"Back to situation client"} />}
        </div >
    );
};

export default PrintINTDEB;